import { FC } from 'react'
import SortBy from './filter/SortBy'
import Icon from './elements/Icon'

interface Props {
  total: number
  updatedOn: Date
  onFilterClick: () => void
}

const SortBar: FC<Props> = ({ total, updatedOn, onFilterClick }) => {
  return (
    <div className="flex justify-between items-center lg:items-end mb-8">
      <div>
        {updatedOn && (
          <p className="text-xs lg:text-sm text-gray-700 leading-4 mb-2">
            Updated on{' '}
            {updatedOn.toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
          </p>
        )}
        <p
          className="text-xs lg:text-sm text-gray-700 leading-4 mb-0"
          data-testid="agent-count"
        >
          {total} {total > 1 || total === 0 ? 'agents' : 'agent'} found based on
          our current data
        </p>
      </div>

      <SortBy className="hidden lg:block" />

      <button
        className="Button Button--secondary Button--small text-sm ml-6 lg:hidden"
        style={{ minWidth: '134px' }}
        data-testid="mobile-filter-button"
        onClick={onFilterClick}
      >
        <Icon variant="filter" className="Icon--xs mr-2" />
        Filters
      </button>
    </div>
  )
}

export default SortBar
